import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

declare var addthis: any;

@Component({
  selector: 'modal-share',
  templateUrl: 'modal-share.html'
})
export class ModalShare {

  public OBJECTID: any;
  public nomNau: any;
  public prefixUrl: string;

  constructor(public viewCtrl: ViewController, public navParams: NavParams) {
    setTimeout(function () { addthis.toolbox('.addthis_toolbox'); }, 100);
    this.OBJECTID = this.navParams.get("OBJECTID");
    this.nomNau = this.navParams.get("nomNau");
  }

  ngOnInit() {
    this.prefixUrl = `manlleu.cat/espais-industrials/app/#/detall/${this.OBJECTID}`;
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-share/modal-share.ts